import React,{useEffect,useMemo} from 'react'
import "./WakeUpCallDecision.css";
import Header from "../../../components/Header";
import Remarks from "../../../components/Remarks/Remarks";
import useAuth from '../../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";
 
export default function WakeUpCallDecision() {

  const navigate = useNavigate();
  const location = useLocation();

  const bookedRoomId = location.state?.bookedRoomId || "";
  const bookingId = location.state?.bookingId || "";
  const requestId = location.state?.requestId || "";
  const userId = location.state?.userId || "";
  const status = location.state?.status || "";
  const Data = location.state?.Data || {};

  const formattedStatus = useMemo(() => {
    return  status.replace('_', ' ');
  }, [status]);



  // Refresh Handle
  useAuth();

  // Check Id
  useEffect(()=>{

    const checkId = ()=>{
      if(userId==="" || bookingId==="" || bookedRoomId===""){
        navigate("/bookings");
      }
    }
      checkId();
  },[userId,bookingId,bookedRoomId,navigate]);

  // Function to format the date (e.g., "07 Oct")
  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      return `${day} ${month}`;
  };

  // Function to format the time (e.g., "22:11")
  const formatTime = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
  };

  // Close Request
  const closeRequest = async()=>{
    try{
      const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
      // console.log("Request Cancelled : ",response.data);
      toast.success("Wake Up Call Request Cancelled Successfully");
      navigate("/bookings",{state : {activeRequests : "requests"}});
    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
  }




  return (
    <div className='wakeUpCallDecision'>
      <Header title="Wake up call" />

      <div className='wakeDeci-view'>

        {/* Status */}
        <div className='wakeDeci-status'>
          <h4>{formattedStatus}</h4>
        </div>
        
        {/* Service Room */}
        <div className='wakeDeci-data'>
          <h4>Service Room</h4>
          <div className='wakeDeci-inp'>
            <h5>{Data.service_room}</h5>
          </div>
        </div>

        {/* Date of service */}
        <div className='wakeDeci-data'>
          <h4>Date of service</h4>
          <div className='wakeDeci-inp'>
            <h5>{formatDate(Data.date_time)}</h5>
          </div>
        </div>

        {/* When do you want to be woken up */}
        <div className='wakeDeci-data'>
          <h4>When do you want to be woken up</h4>
          <div className='wakeDeci-inp'>
            <h5>{formatTime(Data.date_time)}</h5>
          </div>
        </div>

        {/* Comments */}
        {Data.additional_comments && 
          <div className='wakeDeci-data'>
            <h4>Comments</h4>
            <div className='wakeDeci-comment'>
              <h5>{Data.additional_comments}</h5>
            </div>
          </div>
        }

      </div>

    {/* Remarks */}
    {
    Data.remarks && 
      <Remarks para={Data.remarks}/>
    }
    {/* Button */}
    {
      !(status === "Completed_Hotel" || status === "Declined_Hotel" || status === "Declined_Guest" || status === "Closed_Hotel" || status === "Closed_Guest") && (
        <div className='wakeDeci-btn'>
          <button onClick={closeRequest}>Cancel Request</button>
        </div>
      )
    }


    </div>
  )
}
